package cc.easyandroid.easycompose.utils

internal actual class Lock actual constructor() {
    actual inline fun <T> synchronizedImpl(block: () -> T): T =
        block()
}